import{__read as t}from"../../_virtual/_tslib.js";import{useState as r,useEffect as n}from"react";function o(o){var i=t(r(void 0),2),u=i[0],e=i[1];return n((function(){o().then((function(t){return e(t)}))}),[]),u}export default o;
